import React, { useEffect, useState } from 'react';

interface Client {
  id: number;
  name: string;
  email: string;
}

export default function Clients() {
  const [clients, setClients] = useState<Client[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // דמה קריאת API - החלף בכתובת השרת שלך
    fetch('https://jsonplaceholder.typicode.com/users')
      .then(res => res.json())
      .then(data => {
        const mapped = data.map((u: any) => ({
          id: u.id,
          name: u.name,
          email: u.email,
        }));
        setClients(mapped);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>טוען לקוחות...</div>;

  return (
    <div>
      <h2>רשימת לקוחות</h2>
      <ul>
        {clients.map(client => (
          <li key={client.id}>
            <strong>{client.name}</strong> - {client.email}
          </li>
        ))}
      </ul>
    </div>
  );
}
